/* eslint-disable global-require */
module.exports = [...require('./Sale/i18n'), 'ails.landingpage.sales.m2'];
